export enum SnackbarStatus {
  error = 'error',
  success = 'success',
  warn = 'warn',
  warning = 'warn',
}
